import { render, staticRenderFns } from "./CustomerServiceBlock.vue?vue&type=template&id=14778185"
import script from "./CustomerServiceBlock.vue?vue&type=script&lang=js"
export * from "./CustomerServiceBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports